var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import { Table as TableMaterial, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import { withStyles } from "@material-ui/core/styles/index";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DataTableCss from "./css/DataTableCss";
import Pagination from './Pagination/';

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table() {
    var _temp, _this, _ret;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      configRow: [],
      datas: [],
      nodatalabel: 'Aucune donnée'
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Table.prototype.onClickFilterHandler = function onClickFilterHandler(datakey) {
    this.props.sortHandler(datakey);
  };
  /**
   * Retourne le nouveau state en fonction des nextProps
   * @param  {[type]} nextProps [description]
   * @param  {[type]} prevState [description]
   * @return {[type]}           [description]
   */


  Table.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var newState = _extends({}, prevState);

    if (nextProps.datas !== prevState.datas || nextProps.configRow !== prevState.configRow) {
      newState = _extends({}, newState, {
        configRow: nextProps.configRow,
        datas: nextProps.datas
      });
    }

    if (!!nextProps.nodatalabel && nextProps.nodatalabel !== prevState.nodatalabel) {
      newState = _extends({}, newState, {
        nodatalabel: nextProps.nodatalabel
      });
    }

    return newState;
  };
  /**
   * Retourne le header avec ou sans la fonction de Trie
   * @param  {[type]} config [description]
   * @param  {[type]} index  [description]
   * @return {[type]}        [description]
   */


  Table.prototype.getHeaderContent = function getHeaderContent(config, index) {
    var _props = this.props,
        order = _props.order,
        orderBy = _props.orderBy,
        classes = _props.classes;

    if (config.sortable) {
      return React.createElement(TableCell, {
        className: config.className,
        key: index,
        sortDirection: orderBy === config.datakey ? order : false
      }, React.createElement(TableSortLabel, {
        active: orderBy === config.datakey,
        direction: order,
        onClick: this.onClickFilterHandler.bind(this, config.datakey),
        className: classes.headerLabels
      }, config.title));
    } else {
      return React.createElement(TableCell, {
        className: config.className,
        key: index,
        style: {
          fontSize: '.75rem',
          color: 'rgba(0, 0, 0, 0.54)'
        }
      }, ' ', config.title, ' ');
    }
  };
  /**
   * Retourne les Headers
   * @return {[type]} [description]
   */


  Table.prototype.getHeaders = function getHeaders() {
    var _this2 = this;

    return this.state.configRow.map(function (config, index) {
      return _this2.getHeaderContent(config, index);
    });
  };

  Table.prototype.getClassName = function getClassName(obj, config) {
    var row_classes = this.props.rowClassName ? this.props.rowClassName(obj) : null;
    return (row_classes ? row_classes : '') + ' ' + config.className;
  };
  /**
   * Génère le body du tableau
   * @return {[type]} [description]
   */


  Table.prototype.getBody = function getBody() {
    var _this3 = this;

    var rows = [];
    this.state.datas.forEach(function (d, i) {
      rows.push(React.createElement(TableRow, {
        key: i
      }, _this3.state.configRow.map(function (config, index) {
        return React.createElement(TableCell, {
          className: _this3.getClassName(d, config),
          key: index
        }, config.format(d, config.datakey));
      })));
    });
    return rows.length === 0 ? React.createElement(TableRow, null, React.createElement(TableCell, null, this.state.nodatalabel)) : rows;
  };
  /**
   * Rendu Final
   * @return {[type]} [description]
   */


  Table.prototype.render = function render() {
    var _props2 = this.props,
        showPagination = _props2.showPagination,
        nbDatas = _props2.nbDatas,
        handleChangePage = _props2.handleChangePage,
        handleChangeRowsPerPage = _props2.handleChangeRowsPerPage,
        page = _props2.page,
        rowsPerPage = _props2.rowsPerPage;
    return React.createElement(TableMaterial, {
      xs: 12
    }, React.createElement(TableHead, null, React.createElement(TableRow, null, this.getHeaders())), React.createElement(TableBody, null, this.getBody()), React.createElement(Pagination, {
      showPagination: showPagination,
      nbDatas: nbDatas,
      handleChangePage: handleChangePage,
      handleChangeRowsPerPage: handleChangeRowsPerPage,
      page: page,
      rowsPerPage: rowsPerPage,
      labelRowsPerPage: this.props.labelRowsPerPage,
      labelDisplayedRows: this.props.labelDisplayedRows,
      rowsPerPageOptions: this.props.rowsPerPageOptions
    }));
  };

  return Table;
}(Component);

Table.propTypes = process.env.NODE_ENV !== "production" ? {
  datas: PropTypes.array.isRequired,
  configRow: PropTypes.array.isRequired,
  nbDatas: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  showPagination: PropTypes.bool.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangeRowsPerPage: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortHandler: PropTypes.func.isRequired,
  nodatalabel: PropTypes.string,
  labelRowsPerPage: PropTypes.string,
  labelDisplayedRows: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  rowClassName: PropTypes.func
} : {};
export default withStyles(DataTableCss)(Table);